import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Http} from "@angular/http";
import {AppConfig} from "../app.config";
import {Doctor} from "../models/doctor";

@Injectable()
export class DoctorsService extends BaseService {

  constructor(private http: Http, private config: AppConfig) {

    super();
  }

  getAll() {
    return this.http.get(this.config.apiUrl + '/doctors/all/', this.jwt(true))
       .map(res => res.json());
  }

  getById(_id) {
    return this.http.get(this.config.apiUrl + '/doctors/all/' + _id+"/", this.jwt(true))
       .map(res => res.json());
  }

  create(doctor) {
    return this.http.post(this.config.apiUrl + '/doctors/', doctor, this.jwt(true));
  }

  update(doctor) {
    return this.http.put(this.config.apiUrl + '/doctors/' + doctor._id, doctor, this.jwt(true));
  }

  delete(_id) {
    return this.http.delete(this.config.apiUrl + '/doctors/' + _id, this.jwt(true));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/doctors.service.ts